import { render, staticRenderFns } from "./receiveLogTable.vue?vue&type=template&id=f70936e6&"
import script from "./receiveLogTable.vue?vue&type=script&lang=js&"
export * from "./receiveLogTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/tsunagaru-v3-app-mintenant/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f70936e6')) {
      api.createRecord('f70936e6', component.options)
    } else {
      api.reload('f70936e6', component.options)
    }
    module.hot.accept("./receiveLogTable.vue?vue&type=template&id=f70936e6&", function () {
      api.rerender('f70936e6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/src/shared/components/receiveLogTable.vue"
export default component.exports